/* eslint-disable default-case */
import { license } from '../constants';
import produce from 'immer';

const licenseInitialState = {
  data: [],
  total: 0,
  page: 1,
  pageSize: 20,
  sort: undefined,
  filter: undefined,
  error: '',
  isFetching: false,
  isFetchingFinished: false,
  isCreating: false,
  isCreatingFinished: false,
  isApproving: false,
  isApprovingFinished: false,
  isRejecting: false,
  isRejectingFinished: false,

  seedUpload: {
    isSeedUploading: false,
    isSeedUploadingFinished: false,
    error: '',
    signature: []
  },

  contract: {
    isContractFetching: false,
    isContractFetchingFinished: false,
    isContractUploading: false,
    isContractUploadingFinished: false,
    error: '',
    contractID: ''
  }
};

const licenseReducer = produce((draft, action) => {
  switch (action.type) {
    // fetch
    case license.FETCH_LICENSE_REQUEST: {
      draft.error = '';
      draft.isFetching = true;

      return;
    }
    case license.FETCH_LICENSE_SUCCESS: {
      draft.data = action.licenses.requests;
      draft.total = action.licenses.total;
      draft.page = action.licenses.page;
      draft.pageSize = action.licenses.pageSize;
      draft.sort = action.licenses.sort;
      draft.filter = action.licenses.filter;
      draft.isFetching = false;
      draft.isFetchingFinished = true;

      return;
    }
    case license.FETCH_LICENSE_FAILED: {
      draft.error = action.error;
      draft.isFetching = false;
      draft.isFetchingFinished = true;

      return;
    }
    case license.FETCH_LICENSE_STATUS_RESET: {
      draft.isFetchingFinished = false;

      return;
    }
    // create
    case license.CREATE_LICENSE_REQUEST: {
      draft.error = '';
      draft.isCreating = true;

      return;
    }
    case license.CREATE_LICENSE_SUCCESS: {
      draft.data = action.licenses.requests;
      draft.total = action.licenses.total;
      draft.page = action.licenses.page;
      draft.pageSize = action.licenses.pageSize;
      draft.isCreating = false;
      draft.isCreatingFinished = true;

      return;
    }
    case license.CREATE_LICENSE_FAILED: {
      draft.error = action.error;
      draft.isCreating = false;
      draft.isCreatingFinished = true;

      return;
    }
    case license.CREATE_LICENSE_STATUS_RESET: {
      draft.isCreatingFinished = false;

      return;
    }
    // approve
    case license.APPROVE_LICENSE_REQUEST: {
      draft.error = '';
      draft.isApproving = true;

      return;
    }
    case license.APPROVE_LICENSE_SUCCESS: {
      draft.data = action.licenses.requests;
      draft.total = action.licenses.total;
      draft.page = action.licenses.page;
      draft.pageSize = action.licenses.pageSize;
      draft.isApproving = false;
      draft.isApprovingFinished = true;

      return;
    }
    case license.APPROVE_LICENSE_FAILED: {
      draft.error = action.error;
      draft.isApproving = false;
      draft.isApprovingFinished = true;

      return;
    }
    case license.APPROVE_LICENSE_STATUS_RESET: {
      draft.isApprovingFinished = false;

      return;
    }
    // reject
    case license.REJECT_LICENSE_REQUEST: {
      draft.error = '';
      draft.isRejecting = true;

      return;
    }
    case license.REJECT_LICENSE_SUCCESS: {
      draft.data = action.licenses.requests;
      draft.total = action.licenses.total;
      draft.page = action.licenses.page;
      draft.pageSize = action.licenses.pageSize;
      draft.isRejecting = false;
      draft.isRejectingFinished = true;

      return;
    }
    case license.REJECT_LICENSE_FAILED: {
      draft.error = action.error;
      draft.isRejecting = false;
      draft.isRejectingFinished = true;

      return;
    }
    case license.REJECT_LICENSE_STATUS_RESET: {
      draft.isRejectingFinished = false;

      return;
    }
    // seed upload
    case license.UPLOAD_SEED_REQUEST: {
      draft.seedUpload.signature = [];
      draft.seedUpload.error = '';
      draft.seedUpload.isSeedUploading = true;

      return;
    }
    case license.UPLOAD_SEED_SUCCESS: {
      draft.seedUpload.signature = action.signature;
      draft.seedUpload.isSeedUploading = false;
      draft.seedUpload.isSeedUploadingFinished = true;

      return;
    }
    case license.UPLOAD_SEED_FAILED: {
      draft.seedUpload.error = action.error;
      draft.seedUpload.isSeedUploading = false;
      draft.seedUpload.isSeedUploadingFinished = true;

      return;
    }
    case license.UPLOAD_SEED_STATUS_RESET: {
      draft.seedUpload.isSeedUploadingFinished = false;

      return;
    }
    // fetch contract file
    case license.FETCH_CONTRACT_REQUEST: {
      draft.contract.error = '';
      draft.contract.isContractFetching = true;

      return;
    }
    case license.FETCH_CONTRACT_SUCCESS: {
      draft.contract.isContractFetching = false;
      draft.contract.isContractFetchingFinished = true;

      return;
    }
    case license.FETCH_CONTRACT_FAILED: {
      draft.contract.error = action.error;
      draft.contract.isContractFetching = false;
      draft.contract.isContractFetchingFinished = true;

      return;
    }
    case license.FETCH_CONTRACT_STATUS_RESET: {
      draft.contract.isContractFetchingFinished = false;

      return;
    }
    // contract upload
    case license.UPLOAD_CONTRACT_REQUEST: {
      draft.contract.contractID = '';
      draft.contract.error = '';
      draft.contract.isContractUploading = true;

      return;
    }
    case license.UPLOAD_CONTRACT_SUCCESS: {
      draft.contract.contractID = action.contractID;
      draft.contract.isContractUploading = false;
      draft.contract.isContractUploadingFinished = true;

      return;
    }
    case license.UPLOAD_CONTRACT_FAILED: {
      draft.contract.error = action.error;
      draft.contract.isContractUploading = false;
      draft.contract.isContractUploadingFinished = true;

      return;
    }
    case license.UPLOAD_CONTRACT_STATUS_RESET: {
      draft.contract.isContractUploadingFinished = false;

      return;
    }
    default:
      return;
  }
}, licenseInitialState);

export default licenseReducer;
